<template>
  <!-- <nav01 title="客服"></nav01> -->
  <div class="chat-detail">
    <iframe :src="state.kefuUrl" frameborder="0"></iframe>
  </div>
</template>
<script>
export default {
  name: "newserviceChatAiqu",
};
</script>
<script setup>
import { reactive, onMounted } from "vue";
import { useRoute } from "vue-router";
import { getKefuInfo, getUserInfo } from "../../api/user";
import { getQueryString } from "../../utils/location";
// import touxiang from "@/assets/touxiang_reset.png";

const defaultAvatar = require("../../assets/touxiang_reset.png");

const route = useRoute();
const state = reactive({
  kefuUrl: "",
  gid: "",
  uid: "",
  user_info: {},
  deviceType: false,
});

onMounted(() => {
  state.gid = route.query.gid ? getQueryString("gid") : "";
  state.uid = route.query.uid ? getQueryString("uid") : "";
  getInfo();
});

const getInfo = () => {
  getKefuInfo({
    uid: getQueryString("uid"),
    gid: getQueryString("gid"),
  }).then((res) => {
    console.log("获取用户信息", res);
    if (res.data.code == 1) {
      state.kefuUrl = res.data.data.url;
    } 
  });
};

const configUsr = () => {
  
};
</script>
<style scoped>
.chat-detail {
  /* padding-top: calc(70px + constant(safe-area-inset-top));
  padding-top: calc(70px + env(safe-area-inset-top)); */
  height: 100vh;
  width: 100vw;
}
iframe {
  height: 100vh;
  width: 100vw;
  background: #fff;
}
</style>
